import PropTypes from 'prop-types';
import { useCallback, useRef } from 'react';
import ResponseSnackbar from '../ResponseSnackbar';
import { SnackbarContext } from './snackbar-context';

export const SnackbarProvider = ({ children }) => {
  const snackbarRef = useRef();

  const openSnackbar = useCallback((status, message, autoHideDuration = 2000) => {
    snackbarRef.current.open({ status, message, autoHideDuration });
  }, []);

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <SnackbarContext.Provider value={{ openSnackbar }}>
      {children}
      <ResponseSnackbar ref={snackbarRef} />
    </SnackbarContext.Provider>
  );
};

SnackbarProvider.propTypes = {
  children: PropTypes.node,
};
